var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesIcon6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.591 55.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#594cda;}.cls-2{fill:#eb427e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-icon-6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.813,55.556A27.778,27.778,0,1,1,58.591,27.778,27.777,27.777,0,0,1,30.813,55.556Zm2.778-27.778V13.889H28.035V33.333H44.7V27.778H33.591Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.608,32.194h9.837a8.608,8.608,0,1,1,0,17.215H8.608A8.608,8.608,0,0,1,8.608,32.194Zm9.837,12.3A3.689,3.689,0,1,0,14.756,40.8,3.689,3.689,0,0,0,18.445,44.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon6);
export default __webpack_public_path__ + "static/media/features-icon-6.230429b89c8711c50f7066569ebda69a.svg";
export { ForwardRef as ReactComponent };